import {api} from './api';

export type AgeniumQuestionTranscript = {
    section: string;
    question: string;
    answer?: string;
    lastModifiedDate?: string;
};

export const getTranscript = async (caseId: string): Promise<AgeniumQuestionTranscript[]> => {
    const {data} = await api.get(`/case/${caseId}/transcript`, {
        requireAuth: true,
    });

    return data;
};
